import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBaseCheck = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M307.207 716.799l-199.111-199.111c-22.187-22.187-57.458-22.187-79.645 0s-22.187 57.458 0 79.645l238.365 238.361c22.187 22.187 58.027 22.187 80.213 0l603.024-602.451c22.187-22.187 22.187-57.458 0-79.644s-57.46-22.187-79.647 0l-563.2 563.2z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgBaseCheck);
export default ForwardRef;
